import * as React from 'react';

/**
 * useWindowResize
 *
 * @description
 * Provides windows resize event listener to support layouts or components that are
 * rendered based on screen size.
 *
 * TIP: be aware of how many resize listeners are active at a time. It could be best to pass
 * value from common parent down to children rather than subscribing throughout the component tree.
 */
export default function useWindowResize(): {
    windowWidth: number;
    windowHeight: number;
    hasMediumScreen: boolean;
    hasLargeScreen: boolean;
} {
    const [windowWidth, setWindowWidth] = React.useState<number>(window.innerWidth);
    const [windowHeight, setWindowHeight] = React.useState<number>(window.innerHeight);

    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
        setWindowHeight(window.innerHeight);
    };

    React.useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);

        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);

    return {
        windowWidth,
        windowHeight,
        hasMediumScreen: windowWidth >= 980,
        hasLargeScreen: windowWidth >= 1280,
    };
}
